import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs", "refKey"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import useMergedRefs from 'hooks/useMergedRefs';
import { useComboboxContext } from './Combobox';
import { jsx as _jsx } from "react/jsx-runtime";
var ComboboxInput = /*#__PURE__*/forwardRef(function (props, outerRef) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'input' : _props$as,
    forwardedAs = props.forwardedAs,
    _props$refKey = props.refKey,
    refKey = _props$refKey === void 0 ? 'ref' : _props$refKey,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useComboboxContext = useComboboxContext(),
    getInputProps = _useComboboxContext.getInputProps,
    setReferenceRef = _useComboboxContext.popover.setReferenceRef;

  // If there's a custom refKey, use that as the popover target
  // and pass the regular ref on as usual
  // Otherwise merge the refs and attach them to the default one
  var mergedRefs = useMergedRefs([setReferenceRef, outerRef]);
  var mergedCustomRefs = useMergedRefs([setReferenceRef, refKey in otherProps ? otherProps[refKey] : undefined]);
  var refs = {
    ref: refKey !== 'ref' ? outerRef : mergedRefs
  };
  if (refKey !== 'ref') {
    refs[refKey] = mergedCustomRefs;
  }
  if ('onChange' in otherProps || 'value' in otherProps) {
    // eslint-disable-next-line no-console
    console.warn('ComboboxInput: `onChange` or `value` props were found on a ComboboxInput instance. This can lead to unexpected behaviour, please use the the `inputValue` and `onInputChange` props on the parent `Combobox` component instead.');
  }
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread({}, getInputProps(otherProps)), refs), {}, {
    as: forwardedAs
  }));
});
ComboboxInput.displayName = 'ComboboxInput';
export default ComboboxInput;